import { Helmet } from "react-helmet";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import Wrapper from "../components/Wrapper/Wrapper";

import classes from "./Search.module.css";

const NotFound = () => {
    return (
        <Wrapper background="rgb(240, 240, 240)">
            <Helmet>
                <title>Stránka nenalezena</title>
            </Helmet>
            <Breadcrumbs />
            <h2 className={classes.headingTop}>Stránka nenalezena</h2>
        </Wrapper>
    )
}

export default NotFound;